import { createPluginFactory } from '@udecode/plate-core';

import { withTrigger } from './withTrigger';

export const ELEMENT_MERGE_FIELD = 'merge-field';
export const ELEMENT_SMART_INPUT = 'smart-input';

/**
 * Enables support for deserializing inserted content from HTML format to Slate format.
 */
export const createMergeFieldsPlugin = createPluginFactory({
  isElement: true,
  isInline: true,
  isMarkableVoid: true,
  isVoid: true,
  key: ELEMENT_MERGE_FIELD,
  withOverrides: withTrigger,
  options: {
    mergeFields: {},
    createSmartInput: (trigger) => ({
      children: [{ text: '' }],
      trigger,
      type: ELEMENT_SMART_INPUT,
    }),
    trigger: '{',
    // Checks if prev char is a whitespace char
    triggerPreviousCharPattern: /^\s?{$/,
    insertSpaceAfterMergeField: false,
  },
  plugins: [
    {
      isElement: true,
      isInline: true,
      isVoid: true,
      key: ELEMENT_SMART_INPUT,
    },
  ],
  serializeHtml: ({ element }) => {
    const { error, value } = element;
    if (error) {
      return <>&lbrace;&lbrace;{value}&rbrace;&rbrace;</>;
    }
    return <>{value}</>;
  },
  /* eslint-disable-next-line no-unused-vars */
  then: (editor, { type, options: { mergeFields } }) => ({
    options: {
      createMergeFieldNode: (value) => {
        if (mergeFields[value]) {
          return { value: mergeFields[value] };
        }
        return { value, error: true };
      },
    },
    deserializeHtml: {
      getNode: (el) => {
        const value = el.getAttribute('merge-field');
        const error = el.getAttribute('merge-field-error');
        return {
          type,
          value,
          children: [{ text: '' }],
          error,
        };
      },
      rules: [
        {
          validAttribute: 'merge-field',
          validNodeName: 'SPAN',
        },
      ],
    },
  }),
});
